import * as yup from 'yup';

// Configure global Yup locale for French error messages
yup.setLocale({
  mixed: {
    required: 'Ce champ est obligatoire',
    notType: 'Format invalide',
  },
  string: {
    email: "Format d'email invalide",
    matches: 'Format invalide',
  },
  number: {
    positive: 'Doit être un nombre positif',
    integer: 'Doit être un nombre entier',
  },
});

export default yup;